'use client'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@/shared/ui/dialog'
import { useState } from 'react'
import { ConfirmEmailSendComplete } from './confirm-email-send-complete'
import { ConfirmEmailSendForm } from './confirm-email-send-form'
import { useSession } from 'next-auth/react'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
export interface EmailVerifyDialogProps {
  trigger: React.ReactNode
}

export const ConfirmEmailSendDialog = ({ trigger }: EmailVerifyDialogProps) => {
  const [sendedEmail, setSendedEmail] = useState('')
  const session = useSession()

  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          session.update({})
        }
      }}
    >
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        onPointerDownOutside={(event) => {
          event.stopPropagation()
          event.preventDefault()
        }}
      >
        <DialogTitle>
          <VisuallyHidden.Root>ConfirmEmailSendDialog</VisuallyHidden.Root>
        </DialogTitle>
        {!sendedEmail && (
          <ConfirmEmailSendForm
            onSuccess={(email: string) => {
              setSendedEmail(email)
            }}
          />
        )}
        {sendedEmail && <ConfirmEmailSendComplete email={sendedEmail} />}
      </DialogContent>
    </Dialog>
  )
}
